import { render, staticRenderFns } from "./Convenientservice.vue?vue&type=template&id=93a723ba&"
import script from "./Convenientservice.vue?vue&type=script&lang=js&"
export * from "./Convenientservice.vue?vue&type=script&lang=js&"
import style0 from "./Convenientservice.vue?vue&type=style&index=0&id=93a723ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports